import React, { FC } from 'react'
import styles from './ClaimTableHeader.module.css'
import leftArrowIcon from '../../assets/icons/arrowLeft.svg'
import rightArrowIcon from '../../assets/icons/arrowRight.svg'
import filtersIcon from '../../assets/icons/filters.svg'
import SwipeCheckbox from '../UI/SwipeCheckbox/SwipeCheckbox'
import CustomButton from '../UI/CustomButton/CustomButton'
import { useMediaQuery } from 'react-responsive'
import { translateMonthName } from '../CustomCalendar/utils/helpers/date/translateMonts'

export type ClaimTableHeaderPropsType = {
  weekMode: boolean
  fromCurrentPlatform?: boolean
  yearsAndMonth: string
  selectPlatfrom?: JSX.Element
  onOpenClaimFilters: () => void
  onPrevClickHandler: () => void
  onNextClickHandler: () => void
  onSwipeHandler: (checked: boolean) => void
  currentDate: {
    month: string
    year: number
  }
}

const ClaimTableHeader: FC<ClaimTableHeaderPropsType> = ({
  weekMode,
  fromCurrentPlatform,
  yearsAndMonth,
  onOpenClaimFilters,
  onPrevClickHandler,
  onNextClickHandler,
  onSwipeHandler,
  currentDate,
  selectPlatfrom,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  return (
    <div className={styles.claimTableHeader}>
      <div className={styles.container}>
        {!weekMode ? (
          <div className={styles.leftBlock}>
            <div className={styles.dateControlBlock}>
              <div className={styles.leftArrowBlock} onClick={onPrevClickHandler}>
                <img className={styles.leftArrowIcon} src={leftArrowIcon} alt='leftArrowIcon' />
              </div>
              <h2 className={styles.dateBlock}>{`${translateMonthName(
                currentDate.month,
              )}, ${yearsAndMonth.slice(0, 4)}`}</h2>
              <div className={styles.rightArrowBlock} onClick={onNextClickHandler}>
                <img className={styles.rightArrowIcon} src={rightArrowIcon} alt='rightArrowIcon' />
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
        <div className={styles.rightBlock}>
          {selectPlatfrom}
          {!fromCurrentPlatform && !isMobile && (
            <CustomButton
              title='Фильтры'
              iconSrc={filtersIcon}
              className={styles.filtersBtn}
              onClick={onOpenClaimFilters}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ClaimTableHeader
